function numberWithSpace(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}


$('#price-slider1').ionRangeSlider({
    type: "double",
    grid: false,
    min: 120000,
    max: 320000,
    from: 160000,
    to: 320000,
    hide_min_max: true,
    onChange: function (data) {
        
    },
    onStart: function (data) {
        if(data.min != data.from){
            $(data.slider).find('.irs-handle.from').addClass('state_changed');
        }else{
            $(data.slider).find('.irs-handle.from').removeClass('state_changed');
        }
        if(data.max != data.to){
            $(data.slider).find('.irs-handle.to').addClass('state_changed');
        }else{
            $(data.slider).find('.irs-handle.to').removeClass('state_changed');
        }
    },
    onFinish: function (data) {
        if(data.min != data.from){
            $(data.slider).find('.irs-handle.from').addClass('state_changed');
        }else{
            $(data.slider).find('.irs-handle.from').removeClass('state_changed');
        }
        if(data.max != data.to){
            $(data.slider).find('.irs-handle.to').addClass('state_changed');
        }else{
            $(data.slider).find('.irs-handle.to').removeClass('state_changed');
        }
    },
    onUpdate: function (data) {
    },
    prettify: function (num) {
        return numberWithSpace(num);
    }
});

$('.js-benefits-filter').on('click', function(e){
    e.preventDefault();
    if($( window ).width() > 1180) {
        $('.benefits-dropdown').toggleClass('active');
    } else {
        $('.benefits-dropdown-mobile').toggleClass('active');
    }
});

$('.js-refresh-benefits').on('click', function(e){
    e.preventDefault();
    $('.benefits-dropdown input').prop('checked', false);
    $('.js-benefits-mobile').removeClass('active');

    $('.benefits-filter .items').text('');
    $('.benefits-filter .js-title').removeClass('active');
});

// $('.js-benefits-mobile').on('click', function(e){
//     let $this = $(this);
  
//     let id = $this.data('id');
//     let $ch = $(`#${id}`);
//     $ch.attr("checked", !$ch.attr("checked"));
//     document.querySelectorAll('.js-benefits-mobile').forEach(el => el.classList.remove('active'));
//     //console.log(document.querySelector(`#${id}`), $ch )

//     if($ch.attr("checked")) {
//         $this.addClass('active');
//     } else {
//         $this.removeClass('active');
//     }
// });

$('.aparts-filter-mob-js').on('click', function() {
    $(`.aparts-filter`).slideToggle("slow", () => {}); 
})

let dataApartment = {title: ''};
const apartment = {
    init: () => {
        $('.benefits-list .item input, .benefits-dropdown-mobile .js-benefits-mobile').on('click', function() {

            dataApartment = {title: ''};
            dataApartment.title += $(this).find('.title').text();
            // $('.benefits-list .item').each(function() {
            //     const $this = $(this);
            //     if($this.find('input').is(":checked")) {
            //         dataApartment.title += $this.find('.title').text() + ",";
            //     }
            // });
            let name = this.name;
            if(name == undefined) {
                const id = this.dataset.id;
                const elInput = document.querySelector(`#${id}`);
                elInput.checked = !elInput.checked;
                this.classList.toggle('active');
                document.querySelectorAll('.js-benefits-mobile').forEach(el => {
                    if(el.dataset.id != id) el.classList.remove('active');
                });
          
                name = elInput.name;
            } else {
                if(this.checked) {
                    const id = this.id;
                    const elTitle = document.querySelector(`.js-benefits-mobile[data-id="${id}"] .title`);
                    dataApartment.title = elTitle.innerHTML;
                }
            }

            document.querySelectorAll('.benefits-list .item input').forEach(el => {
                if(el.name != name) {
                    el.checked = false;
                }
            });

            if(dataApartment.title === '') {
                $('.benefits-filter .items').text('');
                $('.benefits-filter .js-title').removeClass('active');
                return;
            }
    
            $('.benefits-filter .items').text(dataApartment.title);
            $('.benefits-filter .js-title').addClass('active');

            if(this.classList.contains('js-benefits-mobile')) {
                if(!this.classList.contains('active')) {
                    $('.benefits-filter .items').text('');
                    $('.benefits-filter .js-title').removeClass('active');
                }
            }
        });

        // add small house image url
        const house = $('.page').data('house');
        const number = $('.page').data('number');
        const data = dataCore[house];
   
        $('.aparments-floor-plan svg a').each(function() {
            let $this = $(this);
            let id = $this.attr('id');

            if(data[id] == undefined) return;
            if(data[id]['status'] === 'Parduotas') $this.addClass('sold');
            else if(data[id]['status'] === 'Rezervuotas') $this.addClass('reserved');

            if(data[id]['status'] != 'Parduotas') {
                let link = window.location.pathname.split(number)[0].slice(0, -2);
                
                link += `${data[id]['floor']}/${data[id]['number']}`;
                $this.attr("href", link);
            } else {
                // disabled sold floors
                $this.on('click', function(e) {e.preventDefault();});
            }
        })

        $('.benefits-filter .items').text('');

    }

}

apartment.init();